<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 17:53:28
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 15:05:09
 * @FilePath: \zhucai_user\src\pages\member\child\bm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">我的证书</div>
    <div class="my-content">
      <div class="my-search-box">
        <el-select
          v-model="getListData.ClassifyID"
          placeholder="证书类型"
          clearable
          @change="getList"
        >
          <el-option
            v-for="(it, i) in certificateTypeList"
            :key="i"
            :label="it.ClassifyName"
            :value="it.ClassifyID"
          />
        </el-select>
        <div class="my-search">
          <i class="el-icon-search" @click="getList"></i>
          <input
            type="text"
            @keyup.enter="getList"
            v-model="getListData.CertName"
            placeholder="搜索证书分类名称"
          />
        </div>
        <el-select
          v-model="getListData.StatusID"
          placeholder="证书状态"
          clearable
          @change="getList"
        >
          <el-option
            v-for="(it, i) in statusOptions"
            :key="i"
            :label="it.label"
            :value="it.value"
          />
        </el-select>
        <div class="my-dateRange">
          <el-date-picker
            v-model="getListData.StartDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="证书开始时间"
          >
          </el-date-picker>
          <span class="heng">-</span>
          <el-date-picker
            v-model="getListData.EndDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="证书结束时间"
          >
          </el-date-picker>
        </div>
        <el-button @click="getList" class="search-btn">搜索</el-button>
      </div>
      <el-table v-loading="isLoading" :data="tableData" class="mt20">
        <el-table-column prop="ClassifyName" label="证书类型">
        </el-table-column>
        <el-table-column prop="CertName" label="证书分类" align="center">
        </el-table-column>
        <el-table-column prop="CertLevel" label="证书级别" align="center">
        </el-table-column>
        <el-table-column
          prop="IsContinuingEducation"
          label="是否继续教育"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.IsContinuingEducation ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ValidityYearTxt"
          label="证书有效期"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ExpirationDateTxt"
          label="到期时间"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="StatusID"
          label="证书状态"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span class="StatusID">{{ scope.row.StatusTxt }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="240" align="center">
          <template slot-scope="scope">
            <el-button class="table-btn" @click="hanldDetail(scope.row)">
              查看
            </el-button>
            <el-button class="table-btn" @click="feedback(scope.row)">
              反馈
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination
        :total="total"
        :pageSize="getListData.PageSize"
        v-model="getListData.PageIndex"
      ></my-pagination>
    </div>
    <freebackDialog ref="dialog" :id="id" @closePop="close"></freebackDialog>
  </div>
</template>

<script>
import { Classify_GetList, GetMyCertList } from "@/api/member";
import freebackDialog from "./child/freebackDialog";
import myPagination from "@/components/myPagination.vue";
export default {
  components: { myPagination, freebackDialog },
  name: "cert",
  data() {
    return {
      id: 0,
      SubjectID: 0,
      dialogShow: false,
      formList: [],
      certificateTypeList: [], //证书类型
      statusOptions: [
        { label: "已失效", value: 0 },
        { label: "生效中", value: 1 },
      ],
      isLoading: false,
      total: 0,
      tableData: [],
      getListData: {
        CertName: "",
        StartDate: "",
        EndDate: "",
        ClassifyID: "",
        StatusID: "",
        PageIndex: 1,
        PageSize: 10,
      },
    };
  },
  mounted() {
    this.getClassifyList();
    this.getList();
  },
  methods: {
    getClassifyList() {
      Classify_GetList().then((res) => {
        this.certificateTypeList = res.data;
      });
    },
    close() {
      this.getList();
    },
    feedback(row) {
      this.id = row.CertID;
      this.$refs.dialog.open();
    },

    hanldDetail(data) {
      this.$router.push({
        path: "/member/certDetail",
        query: {
          CertID: data.CertID,
        },
      });
    },
    getList() {
      this.isLoading = true;
      const data = {
        ...this.getListData,
      };
      GetMyCertList(data).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.tableData = res.data;
      });
    },
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.my-search-box {
  .my-search {
    width: 251px;
  }
  .el-select {
    ::v-deep .el-input__inner {
      width: 201px;
      height: 47px;
      background: #f6f8fc;
      border-radius: 23px;
      border: 1px solid #e6e6e6;
    }
  }
  .el-date-editor {
    width: 180px;
    height: 47px;
    ::v-deep .el-input__inner {
      width: 180px;
      height: 47px;
      background: #f6f8fc;
      border-radius: 23px;
      border: 1px solid #e6e6e6;
    }
  }
}

.width510 {
  ::v-deep .el-dialog {
    width: 510px;
  }
}
.bmName {
  font-size: 20px;
  color: #333333;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.time {
  margin-top: 5px;
  font-size: 16px;
  color: #666666;
}
.StatusID {
  font-size: 16px;
  color: #1d79ff;
}
.my-form {
  .mt-form-item {
    margin-bottom: 20px;
    .label {
      font-size: 16px;
      color: #333333;
      margin-bottom: 10px;
    }
    .must {
      color: #ef3d3d;
    }
  }
  ::v-deep .el-input__inner {
    width: 470px;
    height: 46px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
  }
}
.submit-btn {
  width: 144px;
  height: 46px;
  font-size: 16px;
  color: #ffffff;
  background: #1d79ff;
  border-radius: 6px;
}
</style>
